/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {User} from '../models/User';
import type {UserSettings} from '../models/UserSettings';

export interface GetCurrentUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCurrentUserRequest = createAction<PayloadData<void>>('USER_CONTROLLER__GET_CURRENT_USER__REQUEST');
export const getCurrentUserSuccess = createAction<PayloadData<User>>('USER_CONTROLLER__GET_CURRENT_USER__SUCCESS');
export const getCurrentUserFailure = createAction<PayloadData<Error, void, true>>('USER_CONTROLLER__GET_CURRENT_USER__FAILURE');

export const getCurrentUserActions = [
    getCurrentUserRequest,
    getCurrentUserSuccess,
    getCurrentUserFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCurrentUser = (config?: GetCurrentUser$Config) => {
    return {
        CALL_API: {
            types: getCurrentUserActions,
            method: ApiMethods.GET,
            endpoint: `/users/current-user`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetUserSettingsByEmail$Request {
    email: string;
}

export interface GetUserSettingsByEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserSettingsByEmailRequest = createAction<PayloadData<void, GetUserSettingsByEmail$Request>>('USER_CONTROLLER__GET_USER_SETTINGS_BY_EMAIL__REQUEST');
export const getUserSettingsByEmailSuccess = createAction<PayloadData<UserSettings, GetUserSettingsByEmail$Request>>('USER_CONTROLLER__GET_USER_SETTINGS_BY_EMAIL__SUCCESS');
export const getUserSettingsByEmailFailure = createAction<PayloadData<Error, GetUserSettingsByEmail$Request, true>>('USER_CONTROLLER__GET_USER_SETTINGS_BY_EMAIL__FAILURE');

export const getUserSettingsByEmailActions = [
    getUserSettingsByEmailRequest,
    getUserSettingsByEmailSuccess,
    getUserSettingsByEmailFailure
] as const;

/**
 * @param {string} meta.email User email
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserSettingsByEmail = (meta: GetUserSettingsByEmail$Request, config?: GetUserSettingsByEmail$Config) => {
    return {
        CALL_API: {
            types: getUserSettingsByEmailActions,
            method: ApiMethods.GET,
            endpoint: `/users/settings/${meta.email}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsersByEmails$Request {
    emails: Array<string>;
}

export interface GetUsersByEmails$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersByEmailsRequest = createAction<PayloadData<void, GetUsersByEmails$Request>>('USER_CONTROLLER__GET_USERS_BY_EMAILS__REQUEST');
export const getUsersByEmailsSuccess = createAction<PayloadData<Array<User>, GetUsersByEmails$Request>>('USER_CONTROLLER__GET_USERS_BY_EMAILS__SUCCESS');
export const getUsersByEmailsFailure = createAction<PayloadData<Error, GetUsersByEmails$Request, true>>('USER_CONTROLLER__GET_USERS_BY_EMAILS__FAILURE');

export const getUsersByEmailsActions = [
    getUsersByEmailsRequest,
    getUsersByEmailsSuccess,
    getUsersByEmailsFailure
] as const;

/**
 * @param {Array<string>} meta.emails Users Emails
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersByEmails = (meta: GetUsersByEmails$Request, config?: GetUsersByEmails$Config) => {
    const TRANSPORT_GET_PARAMS = {
        emails: meta.emails,
    };
    return {
        CALL_API: {
            types: getUsersByEmailsActions,
            method: ApiMethods.GET,
            endpoint: `/users`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserSettings$Request {
    userSettings: UserSettings;
}

export interface SaveUserSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserSettingsRequest = createAction<PayloadData<void, SaveUserSettings$Request>>('USER_CONTROLLER__SAVE_USER_SETTINGS__REQUEST');
export const saveUserSettingsSuccess = createAction<PayloadData<void, SaveUserSettings$Request>>('USER_CONTROLLER__SAVE_USER_SETTINGS__SUCCESS');
export const saveUserSettingsFailure = createAction<PayloadData<Error, SaveUserSettings$Request, true>>('USER_CONTROLLER__SAVE_USER_SETTINGS__FAILURE');

export const saveUserSettingsActions = [
    saveUserSettingsRequest,
    saveUserSettingsSuccess,
    saveUserSettingsFailure
] as const;

/**
 * @param {UserSettings} meta.userSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserSettings = (meta: SaveUserSettings$Request, config?: SaveUserSettings$Config) => {
    return {
        CALL_API: {
            types: saveUserSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/users/settings/save`,
            TRANSPORT_REQUEST_BODY: meta.userSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SearchUsers$Request {
    searchPhrase: string;
}

export interface SearchUsers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchUsersRequest = createAction<PayloadData<void, SearchUsers$Request>>('USER_CONTROLLER__SEARCH_USERS__REQUEST');
export const searchUsersSuccess = createAction<PayloadData<Array<User>, SearchUsers$Request>>('USER_CONTROLLER__SEARCH_USERS__SUCCESS');
export const searchUsersFailure = createAction<PayloadData<Error, SearchUsers$Request, true>>('USER_CONTROLLER__SEARCH_USERS__FAILURE');

export const searchUsersActions = [
    searchUsersRequest,
    searchUsersSuccess,
    searchUsersFailure
] as const;

/**
 * @param {string} meta.searchPhrase Search Phrase
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchUsers = (meta: SearchUsers$Request, config?: SearchUsers$Config) => {
    const TRANSPORT_GET_PARAMS = {
        searchPhrase: meta.searchPhrase,
    };
    return {
        CALL_API: {
            types: searchUsersActions,
            method: ApiMethods.GET,
            endpoint: `/users/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

